const routes = {
  index: '/',
  microsites: '/microsites',
  siteSettings: '/:siteId/sitesettings',
  publishSite: '/:siteId/publish',
  pageSettings: '/:siteId/:pageId/pagesettings',
  pageContent: '/:siteId/:pageId/pagecontent',
  pageResources: '/:siteId/:pageId/resources',
  pageResourcesTable: '/:siteId/:pageId/resources-table',
  pageQuickLinks: '/:siteId/:pageId/link-resources',
  pageOptionalCopyBlock: '/:siteId/:pageId/optional-copy-block',
  pagePerformance: '/:siteId/:pageId/performance',
  pageTestimonials: '/:siteId/:pageId/testimonials',
  pageChallenge: '/:siteId/:pageId/challenge',
  pageLibraryResources: '/:siteId/:pageId/library-resources',
  pageVideos: '/:siteId/:pageId/videos',
  pageVideosTable: '/:siteId/:pageId/videos-table',
  pageBios: '/:siteId/:pageId/bios',
  externalLink: '/:siteId/:pageId/external-link',
  pageFooter: '/:siteId/:pageId/footer',
  pagePreview: '/:pageId/preview',
  pageBuildPreview: '/:pageId/previewbuild',
  analytics: '/analytics',
  reportsPageviews: '/reports/pageviews',
  micrositeStatistics: '/reports/microsites-statistics',
  reportsMicrositesDetail: '/reports/microsites-detail',
  reportsMicrositesCreate: '/reports/microsites-create',
  reportsMicrositesPageCreate: '/reports/microsites-page-create',
  components: '/components',
  logout: '/logout',
  admin: '/admin',
};

export const documentTitleMap = {
  microsites: 'Project Library',
  admin: 'Admin:Microsite Settings',
  adminLandingPage: 'Admin:LandingPage',
  adminBios: 'Admin:Bios',
  adminBioGroups: 'Admin:Bio Groups',
  adminResources: 'Admin:Resources',
  adminResourceCategories: 'Admin:Resource Categories',
  adminVideos: 'Admin:Videos',
  adminVideoCategories: 'Admin:Video Categories',
  adminHeroImages: 'Admin:Hero Images',
  adminCoBrandLogos: 'Admin:Co Brand Logos',
  adminTemplates: 'Admin:Templates',
  reportPageViews: {
    document: 'Reports:Page Views (GA4)',
    page: 'Pageviews (GA4)',
  },
  micrositeStatistics: {
    document: 'Reports:Pageviews by Microsite',
    page: 'Pageviews by Microsite',
  },
  reportUnusedAssets: {
    document: 'Reports:Unused Assets',
    page: 'Unused Assets',
  },
  reportsMicrositesDetail: {
    document: 'Reports:Microsites Detail',
    page: 'Microsites Detail',
  },
  reportsMicrositesCreate: {
    document: 'Reports:Microsites Created',
    page: 'Microsites Created',
  },
  reportsMicrositesPageCreate: {
    document: 'Reports:Microsites Page Created',
    page: 'Microsites Page Created',
  },
  reportsAssetUsage: {
    document: 'Reports:Asset Usage',
    page: 'Asset Usage',
  },
  siteSettings: 'Site Settings',
  createMicrosite: 'Create Microsite',
  editMicrosite: 'Edit Microsite',
  publish: 'Publish',
  components: 'Components',
};

export default routes;
